"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Render = _interopRequireDefault(require("./Render"));

var _Form = _interopRequireDefault(require("./Form"));

var _ = require("../../");

var defaultAttrs = function defaultAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _.Tools.applyDefaults({
    src: "https://picsum.photos/125/125/?random",
    upload: "",
    width: "",
    height: "",
    title: "",
    alt: "",
    url: ""
  }, attrs);
};

var _default = {
  Render: _Render["default"],
  Form: _Form["default"],
  type: "Image",
  label: "Image",
  description: "Image component to display images or graphics in the page layout.",
  defaultAttrs: defaultAttrs,
  generateContent: function generateContent() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        parent = _ref.parent;

    var content = [{
      id: _.Tools.generateUUID(),
      type: "Image",
      attrs: defaultAttrs(),
      content: []
    }];
    return [{
      id: _.Tools.generateUUID(),
      type: "Row",
      attrs: {
        allowChildren: false
      },
      content: content
    }];
  }
};
exports["default"] = _default;